import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import { POINTS_OF_CONTACT_TABLE_CONSTANTS } from "routes/points_of_contact/points_of_contact_table/PointsOfContactTableV3";
import PointOfContactService from "services/PointOfContact";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";
import { getPointsOfContactTableColumns } from "routes/points_of_contact/points_of_contact_table/PointsOfContactTableColumnsAndFilters";

export const invalidatePointsOfContactQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [POINTS_OF_CONTACT_TABLE_CONSTANTS.queryKey],
  });
};

export const deletePointOfContact = async id => {
  await PointOfContactService.delete(id);
  await invalidatePointsOfContactQuery();
};

export const usePointsOfContactTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getPointsOfContactTableColumns();
    const pointsOfContactTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${POINTS_OF_CONTACT_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: pointsOfContactTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  return { columns };
};
